import { Link } from "react-router-dom";

export default function Footer() {
  // From within the Care Portal footer, "Home" returns the employee to the
  // main California Corporate Chaplains public site (/), giving them an
  // obvious path back to the parent organization. The Care Portal top nav
  // continues to route "Home" to /care-portal — this footer link is
  // intentionally different from the top-nav Home.
  return (
    <footer className="border-t border-slate-200 bg-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 text-slate-900 font-heading">
            <img
              src="/ccchaps-logo.png"
              alt="California Corporate Chaplains"
              className="h-8 w-8 object-contain"
            />
            <span className="h-6 w-px bg-slate-200" aria-hidden="true" />
            <span className="text-sm font-medium text-slate-700">Care Portal</span>
          </div>
          <p className="text-sm text-slate-500 mt-3 leading-relaxed">
            A confidential workplace chaplaincy support portal for employees of enrolled companies.
            Not a medical or therapy service.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-medium mb-3">
            Portal
          </p>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link className="hover:text-slate-900" to="/" data-testid="footer-home-link">Home</Link></li>
            <li><Link className="hover:text-slate-900" to="/care-portal/resources">Resource Library</Link></li>
            <li><Link className="hover:text-slate-900" to="/care-portal/request-support">Request Support</Link></li>
            <li><Link className="hover:text-slate-900" to="/care-portal/admin/login" data-testid="footer-management-login">Management Center Login</Link></li>
            <li><Link className="hover:text-slate-900" to="/chaplain-portal/login" data-testid="footer-chaplain-login">Chaplain Login</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 font-medium mb-3">
            Crisis
          </p>
          <p className="text-sm text-slate-600 leading-relaxed">
            If you are in immediate danger, call <span className="font-semibold text-slate-900">911</span> or
            your local emergency services. This portal is not for medical or mental health emergencies.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <span>© {new Date().getFullYear()} California Corporate Chaplains. Confidential by design.</span>
          <span>Employers receive only aggregate, non-identifying utilization reports.</span>
        </div>
      </div>
    </footer>
  );
}
